import { __extends } from "tslib";
import { GetOpenIdTokenForDeveloperIdentityInput, GetOpenIdTokenForDeveloperIdentityResponse } from "../models/index";
import { deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand, serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { getAwsAuthPlugin } from "@aws-sdk/middleware-signing";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetOpenIdTokenForDeveloperIdentityCommand = /** @class */ (function (_super) {
    __extends(GetOpenIdTokenForDeveloperIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetOpenIdTokenForDeveloperIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetOpenIdTokenForDeveloperIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getAwsAuthPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog,
            outputFilterSensitiveLog: GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetOpenIdTokenForDeveloperIdentityCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand(input, context);
    };
    GetOpenIdTokenForDeveloperIdentityCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand(output, context);
    };
    return GetOpenIdTokenForDeveloperIdentityCommand;
}($Command));
export { GetOpenIdTokenForDeveloperIdentityCommand };
//# sourceMappingURL=GetOpenIdTokenForDeveloperIdentityCommand.js.map